import wixEcomFrontend from 'wix-ecom-frontend';
import store from "store";
import { initialLoading, handleOnPropsChanged, handleOnCartChange } from 'public/Shared/Design/design.js';
import { controllElementVisibility } from 'public/Utilities/common';
import { viewMode } from 'wix-window-frontend';

$w.onReady(async function () {
    console.log("V1.3");
    // Set the state to 'loadingState' before starting initial loading
    await controllElementVisibility('#widgetMainContainer', 'hide');
    $w('#ProgressBarMainMultiStateBox').changeState('loadingState');

    try {
        await initialLoading();
    } finally {
        // Once loading is complete, revert to the appropriate state
        $w('#ProgressBarMainMultiStateBox').changeState('ProgressState');
    }

    wixEcomFrontend.onCartChange(handleOnCartChange);
});

$widget.onPropsChanged(async (oldProps, newProps) => {
    store.set('props', newProps);
    store.set('oldProps', oldProps);

    if (oldProps.isRefreshRequested !== newProps.isRefreshRequested) {
        // Hide container and show loading state
        $w('#ProgressBarMainMultiStateBox').changeState('loadingState');

        try {
            // Wait for loading to complete
            await initialLoading();

            // Add a small delay to ensure DOM is ready (optional, helps with rendering glitches)
            await new Promise((resolve) => setTimeout(resolve, 100));

            // Change state and then reveal container
            $w('#ProgressBarMainMultiStateBox').changeState('ProgressState');
            await controllElementVisibility('#widgetMainContainer', 'show');

        } catch (err) {
            console.log("Refresh failed:", err);
        }
    }

    if (oldProps.showHideWidgetToggleValue !== newProps.showHideWidgetToggleValue) {
        if (newProps.showHideWidgetToggleValue) {
            if (viewMode != 'Editor') {
                await controllElementVisibility('#widgetMainContainer', 'hide');
            }
        }
    }

    if (oldProps.progressBarMinCartValue !== newProps.progressBarMinCartValue ||
        oldProps.progressNoneItem !== newProps.progressNoneItem ||
        oldProps.progressQuarterItem !== newProps.progressHalfItem ||
        oldProps.progress3QuarterItem !== newProps.progress3QuarterItem ||
        oldProps.progressFullItem !== newProps.progressFullItem ||
        oldProps.progressBarDesignDropdownValue !== newProps.progressBarDesignDropdownValue) {

        // Set the state to 'loadingState' before starting initial loading
        try {
            await handleOnPropsChanged(newProps);
        } finally {
            // Once loading is complete, revert to the appropriate state
            $w('#ProgressBarMainMultiStateBox').changeState('ProgressState');
        }
    }

});